module.exports = __webpack_public_path__ + "img/mask_1.6564a58d.png";